export default {"src":"/_next/static/media/filterIcon.6ce2c173.svg","height":478,"width":478};